import DeptLocModel from '../models/deptlocmodel';
const DeptLocsCollection = Backbone.Collection.extend({
  model: DeptLocModel
});

export default DeptLocsCollection;
